/* ============
 * Account Transformer
 * ============
 *
 * The transformer for the account.
 */

import Transformer from '../transformer';

export default class AccountTransformer extends Transformer {
  /**
   * Method used to transform a fetched account
   *
   * @param address The fetched address
   *
   * @returns {Object} The transformed account
   */
  static fetch(address) {
    return {
      street: address ? address.street : null,
      shopName: address ? address.shop_name : null,
      zipCode: address ? address.zip_code : null,
      city: address ? address.city : null,
      company: address ? address.company : null,
      comment: address ? address.comment : null,
      country: address ? address.country : null,
      countryCode: address ? address.country_code : null,
      phone: address ? address.phone : null,
      geoPoint: address ? address.geo_point : null,
      contactEmail: address ? address.contact_email : null,
      contacts: address ? address.contacts : null,
    };
  }

  /**
   * @param address The fetched address
   *
   * @returns {Object} The transformed account
   */
  static send(address) {
    return {
      street: address.street,
      zip_code: address.zipCode,
      city: address.city,
      company: address.company,
      comment: address.comment,
      country: address.country,
      phone: address.phone,
      contacts: address.contacts,
      contact_email: address.contactEmail,
    };
  }

  /**
   * @param address
   * @param otherAddress
   */
  static isSameAddress(address, otherAddress) {
    return (
      address.street === otherAddress.street
      && address.zipCode === otherAddress.zipCode
      && address.city === otherAddress.city
      && address.comment === otherAddress.comment
    );
  }
}
